<template>
  <el-dialog title="分配资源" :visible.sync="dialogVisible" width="500px" @open="fetchAllAdvisers" @close="onClose">
    <el-form :model="form" label-width="100px">
      <el-form-item :label="nameLabel">
        <el-input v-model="form.realName" disabled></el-input>
      </el-form-item>
      <el-form-item label="分配类型" required>
        <el-checkbox-group v-model="form.resourceTypes" @change="onResourceTypesChange">
          <el-checkbox v-if="showStudent" label="留学" :disabled="form.isStudent">分配给留学</el-checkbox>
          <el-checkbox v-if="showJap" label="日语" :disabled="form.isJap">分配给日语</el-checkbox>
          <el-checkbox v-if="showMingye" label="鸣野" :disabled="form.isMingye">分配给鸣野</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-alert v-if="sameWechatHintText" type="error" style="margin-bottom: 12px;" show-icon>{{ sameWechatHintText }}</el-alert>
      <el-form-item label="留学顾问" v-if="showStudent && form.resourceTypes && form.resourceTypes.includes('留学')">
        <el-select v-model="form.adviserID" placeholder="请选择留学顾问" filterable clearable style="width: 100%">
          <el-option v-for="item in allAdviserList" :label="item.realName" :value="item.userID" :key="item.userID"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="留学营销" v-if="showStudent && userIsAdmain && form.resourceTypes && form.resourceTypes.includes('留学')">
        <DeptRoleTeacherSelect v-model="form.marketID" dept="留学" placeholder="请选择部门 → 角色 → 老师" />
      </el-form-item>
      <el-form-item label="日语顾问" v-if="showJap && form.resourceTypes && form.resourceTypes.includes('日语')">
        <el-select v-model="form.jpAdviserID" placeholder="请选择日语顾问" filterable clearable style="width: 100%">
          <el-option v-for="item in allAdviserList" :label="item.realName" :value="item.userID" :key="item.userID"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日语营销" v-if="showJap && userIsAdmain && form.resourceTypes && form.resourceTypes.includes('日语')">
        <DeptRoleTeacherSelect v-model="form.jpMarketID" dept="日语" placeholder="请选择部门 → 角色 → 老师" />
      </el-form-item>
      <el-form-item label="鸣野顾问" v-if="showMingye && form.resourceTypes && form.resourceTypes.includes('鸣野')">
        <el-select v-model="form.myAdviserID" placeholder="请选择鸣野顾问" filterable clearable style="width: 100%">
          <el-option v-for="item in allAdviserList" :label="item.realName" :value="item.userID" :key="item.userID"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="鸣野营销" v-if="showMingye && userIsAdmain && form.resourceTypes && form.resourceTypes.includes('鸣野')">
        <DeptRoleTeacherSelect v-model="form.myMarketID" dept="鸣野" placeholder="请选择部门 → 角色 → 老师" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitAssign" :loading="submiting">保存</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import url from '@/plugins/urlHelper.js';
import user from '@/plugins/user.js';
import DeptRoleTeacherSelect from '@/components/DeptRoleTeacherSelect.vue';

export default {
  name: 'AssignResourceDialog',
  components: { DeptRoleTeacherSelect },
  props: {
    visible: { type: Boolean, default: false },
    form: { type: Object, default: () => ({ resourceTypes: [] }) },
    adviserList: { type: Array, default: () => [] },
    marketList: { type: Array, default: () => [] },
    userIsAdmain: { type: Boolean, default: false },
    showStudent: { type: Boolean, default: true },
    showJap: { type: Boolean, default: true },
    showMingye: { type: Boolean, default: true },
    nameLabel: { type: String, default: '学生姓名' },
    emptyMessage: { type: String, default: '请至少选择一种资源类型（留学、日语或鸣野）' }
  },
  data() {
    return {
      submiting: false,
      // 同微信号下其他记录已是该板块（从 CheckWechatDuplicate 拉取）
      sameWechatBlocks: [],
      // 同微信号重复项的完整信息 [{ blockName, adviserName, marketName, inputTime }]，用于详细提示
      sameWechatItems: []
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(v) {
        this.$emit('update:visible', v);
      }
    },
    // 仅针对「同微信号另一条数据已是该板块」时提示（本条已是则用 disabled，不显示此处）
    sameWechatHintText() {
      const types = (this.form.resourceTypes || []);
      const parts = [];
      if (this.showStudent && types.includes('留学') && this.sameWechatBlocks.includes('留学')) {
        parts.push(this.sameWechatMessage('留学'));
      }
      if (this.showJap && types.includes('日语') && this.sameWechatBlocks.includes('日语')) {
        parts.push(this.sameWechatMessage('日语'));
      }
      if (this.showMingye && types.includes('鸣野') && this.sameWechatBlocks.includes('鸣野')) {
        parts.push(this.sameWechatMessage('鸣野'));
      }
      if (parts.length === 0) return '';
      return parts.join('；');
    }
  },
  methods: {
    // 根据板块名取“该学生已经是xx资源，营销老师：xxx 顾问老师：xxx”文案
    sameWechatMessage(blockName) {
      const item = (this.sameWechatItems || []).find(i => i.blockName === blockName);
      if (!item) return `存在同微信号的${blockName}记录，不能分配${blockName}`;
      const adv = (item.adviserName || '').trim() || '未分配';
      const mkt = (item.marketName || '').trim() || '未分配';
      return `该学生已经是${blockName}资源，营销老师：${mkt} 顾问老师：${adv}`;
    },
    // 勾选时校验：仅处理「同微信号另一条数据已是该板块」→ 提示并取消勾选（本条已是则已 disabled）
    onResourceTypesChange(newVal) {
      const prev = (this.form.resourceTypes || []);
      const added = newVal.filter(t => !prev.includes(t));
      let next = newVal.slice();
      if (added.includes('留学') && this.sameWechatBlocks.includes('留学')) {
        this.$message.error(this.sameWechatMessage('留学'));
        next = next.filter(t => t !== '留学');
      }
      if (added.includes('日语') && this.sameWechatBlocks.includes('日语')) {
        this.$message.error(this.sameWechatMessage('日语'));
        next = next.filter(t => t !== '日语');
      }
      if (added.includes('鸣野') && this.sameWechatBlocks.includes('鸣野')) {
        this.$message.error(this.sameWechatMessage('鸣野'));
        next = next.filter(t => t !== '鸣野');
      }
      if (next.length !== newVal.length) {
        this.$nextTick(() => { this.form.resourceTypes = next; });
      }
    },
    fetchAllAdvisers() {
      const _this = this;
      $.get(url.getStu('GetUsersByRole'), { roleIds: '3,9,11,16,15,19' }, (data) => {
        _this.allAdviserList = data || [];
      });
      const studentID = _this.form.studentID != null ? _this.form.studentID : _this.form.id;
      _this.sameWechatBlocks = [];
      if (!studentID) return;
      $.get(url.getStu('GetStudentModel'), { id: studentID }, (stu) => {
        const wechat = stu && (stu.wechat || stu.Wechat);
        if (!wechat) return;
        $.get(url.getStu('CheckWechatDuplicate'), {
          wechat: wechat,
          isStudent: true,
          isJap: true,
          isMingye: true,
          excludeId: studentID
        }, (res) => {
          const items = (res && res.items) ? res.items : [];
          _this.sameWechatItems = items;
          _this.sameWechatBlocks = items.map(i => i.blockName);
        });
      });
    },
    onClose() {
      this.submiting = false;
      this.sameWechatBlocks = [];
      this.sameWechatItems = [];
    },
    submitAssign() {
      const form = this.form;
      if (!form.resourceTypes || form.resourceTypes.length === 0) {
        this.$message({ type: 'error', message: this.emptyMessage });
        return;
      }
      // 该生已是勾选目标板块的资源时禁止保存（勾选时已拦截，此处兜底）
      if (this.showStudent && form.resourceTypes.includes('留学') && form.isStudent) {
        this.$message({ type: 'error', message: '该学生已经是留学资源' });
        return;
      }
      if (this.showJap && form.resourceTypes.includes('日语') && form.isJap) {
        this.$message({ type: 'error', message: '该学生已经是日语资源' });
        return;
      }
      if (this.showMingye && form.resourceTypes.includes('鸣野') && form.isMingye) {
        this.$message({ type: 'error', message: '该学生已经是鸣野资源' });
        return;
      }
      if (this.sameWechatBlocks.includes('留学') && form.resourceTypes.includes('留学')) {
        this.$message({ type: 'error', message: '存在同微信号的留学记录，不能分配留学' });
        return;
      }
      if (this.sameWechatBlocks.includes('日语') && form.resourceTypes.includes('日语')) {
        this.$message({ type: 'error', message: '存在同微信号的日语记录，不能分配日语' });
        return;
      }
      if (this.sameWechatBlocks.includes('鸣野') && form.resourceTypes.includes('鸣野')) {
        this.$message({ type: 'error', message: '存在同微信号的鸣野记录，不能分配鸣野' });
        return;
      }

      const studentID = form.studentID != null ? form.studentID : form.id;
      const params = {
        studentID: studentID,
        resourceTypes: form.resourceTypes
      };
      // 顾问/营销只传用户选择的值，未选时由后端用当前登录人
      if (this.showStudent && form.resourceTypes.includes('留学')) {
        if (form.adviserID) params.adviserID = form.adviserID;
        if (form.marketID) params.marketID = form.marketID;
      }
      if (this.showJap && form.resourceTypes.includes('日语')) {
        if (form.jpAdviserID) params.jpAdviserID = form.jpAdviserID;
        if (form.jpMarketID) params.jpMarketID = form.jpMarketID;
      }
      if (this.showMingye && form.resourceTypes.includes('鸣野')) {
        if (form.myAdviserID) params.myAdviserID = form.myAdviserID;
        if (form.myMarketID) params.myMarketID = form.myMarketID;
      }

      this.submiting = true;
      const _this = this;
      $.post(url.getStu('AssignResource'), params, (res) => {
        _this.submiting = false;
        if (res.status) {
          _this.dialogVisible = false;
          _this.$emit('success', res);
          _this.$message({ type: 'success', message: res.msg || '分配成功' });
        } else {
          _this.$message({ type: 'error', message: res.msg || '分配失败' });
        }
      }).fail(() => {
        _this.submiting = false;
      });
    }
  }
};
</script>
